import React from 'react'

import { GetCustomerCopyFunc, WORKLIFE_SERVICE_IDS } from '@lyrahealth-inc/shared-app-logic'

import {
  WorkLifeIconDependentCare,
  WorkLifeIconFinancial,
  WorkLifeIconIdentity,
  WorkLifeIconLaw,
} from '../atoms/icons/WorkLifeIcons'

export const dell: GetCustomerCopyFunc = () => {
  return {
    workLifeServices: [
      {
        identifiers: WORKLIFE_SERVICE_IDS.LEGAL_SERVICES,
        title: 'Legal Services',
        iconSvg: <WorkLifeIconLaw size={48} />,
        bullets: [],
        CTA: 'Access legal support',
        PATH: 'https://leplb0050.upoint.ap.alight.com/ah-angular-afirst-web/#/web/dell/contentPage?articleId=A52AE01B-988D-42F0-9A43-2E9668C5CD77',
      },
      {
        identifiers: WORKLIFE_SERVICE_IDS.FINANCIAL_SERVICES,
        title: 'Financial Services',
        iconSvg: <WorkLifeIconFinancial size={48} />,
        bullets: [],
        CTA: 'Access financial support',
        PATH: 'https://leplb0050.upoint.ap.alight.com/ah-angular-afirst-web/#/web/dell/contentPage?articleId=D0F4A9BF-CB29-4993-80C3-429D3AA0811F',
      },
      {
        identifiers: WORKLIFE_SERVICE_IDS.IDENTITY_THEFT,
        title: 'Identity Theft',
        iconSvg: <WorkLifeIconIdentity size={48} />,
        bullets: [],
        CTA: 'Access identity theft support',
        PATH: 'https://leplb0050.upoint.ap.alight.com/ah-angular-afirst-web/#/web/dell/contentPage?articleId=8E5F8F8F-8F8F-8F8F-8F8F-8F8F8F8F8F8F',
      },
      {
        identifiers: WORKLIFE_SERVICE_IDS.DEPENDENT_CARE,
        title: 'Dependent Care',
        iconSvg: <WorkLifeIconDependentCare size={48} />,
        bullets: [],
        CTA: 'Access dependent care support',
        PATH: 'https://leplb0050.upoint.ap.alight.com/ah-angular-afirst-web/#/web/dell/cp/landing6',
      },
    ],
  }
}
